import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const UnauthorizedPage: React.FC = () => {
  const { user, logout } = useAuth();

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <div className="auth-logo">Services Anti-Trafic</div>
          <p className="auth-subtitle">Accès non autorisé</p>
        </div>
        
        <div className="auth-alert auth-alert-error">
          <p>Vous n'avez pas les permissions nécessaires pour accéder à cette page.</p>
        </div>
        
        <div className="space-y-4">
          <div className="text-center">
            <p className="text-charcoal mb-4">
              Vous êtes connecté en tant que : <strong>{user?.firstName} {user?.lastName}</strong>
            </p>
            <p className="text-sm text-charcoal mb-4">
              Rôle : <span className="font-semibold">{user?.role?.name}</span>
            </p>
          </div>
          
          <div className="space-y-2">
            <Link to="/admin" className="auth-button-primary block text-center">
              Retour au tableau de bord
            </Link>
            
            <button 
              onClick={logout}
              className="auth-button-outline w-full"
            >
              Se déconnecter
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnauthorizedPage;
